module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/charlotte-kirschner-84bf8bae45ddd28014341634983752ea.jpg";